import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from "@auth0/auth0-react";
import { AuthProvider } from './context/AuthContext';
import { BillingProvider } from './context/BillingContext';
import { GameSpaceProvider } from './context/GameSpaceContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUDIENCE;

if (!auth0Domain || !auth0ClientId) {
  console.error("Missing Auth0 environment variables. Make sure to set REACT_APP_AUTH0_DOMAIN and REACT_APP_AUTH0_CLIENT_ID in your .env file.");
}
else if (auth0Domain) {
  console.log(`Auth0 domain: ${auth0Domain}`);
}

const onRedirectCallback = (appState) => {
  const targetUrl = appState?.returnTo || '/game-cards';
  console.log('Auth0 callback redirecting to:', targetUrl);
  window.location.href = targetUrl;
};

root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      authorizationParams={{ 
        redirect_uri: `${window.location.origin}/callback`,
        audience: audience,
        scope: "openid profile email offline_access",
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <AuthProvider>
        <GameSpaceProvider>
          <BillingProvider>
            <App />
          </BillingProvider>
        </GameSpaceProvider>
      </AuthProvider>
    </Auth0Provider>
  </BrowserRouter>
);